import { gql } from '@apollo/client';

export const GET_REPORT_QUERY = gql`
query report($reportId: UUID!) {
    report(reportID: $reportId) {
      node {
        id
        reportType
        status
        reportUrl
        reportStartedAt
        reportCompletedAt
      }
    }
  }
`;
